/**
 * Element module.
 * @module src/icon
 */
import { addClass } from './style';
/**
 * Creates a Font Awesome icon tag.
 *
 * @function faIcon
 *
 * @param {string} name - The name of the font awesome icon.
 * @param {Object} [options={}] - The options which are needed to create the element icon.
 * @param {string} [options.kind=fas] - The the kind of icon fas (Solid) far (Regular), etc.
 * @param {string} [options.class=[]] - The list of extra classes for the icon.
 * @return {HTMLElement} - A built icon with given name and options.
 *
 * @example
 * faIcon('road');
 * // returns '<i class="fas fa-road"></i>'
 *
 * @example
 * faIcon('road', { class: ['mr-4', 'text-xl', 'w8'] });
 * // returns '<i class="fas fa-road mr-4 text-xl w-8"></i>'
 *
 * @example
 * faIcon('road', { kind: 'far', class: ['mr-4', 'text-xl', 'w8'] });
 * // returns '<i class="far fa-road mr-4 text-xl w-8"></i>'
 *
 */

export const faIcon = function (name) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const icon = document.createElement('i');
  const iconKind = options.kind || 'fas';
  const customClasses = options.class || [];
  addClass(icon, [iconKind, `fa-${name}`].concat(customClasses));
  return icon;
};